export const categories = [
    {
        id: 1,
        name: "Uteplanter",
        image: "https://customer-assets.emergentagent.com/job_hageplanter-no/artifacts/mk89xwnm_image.png",
        count: "Stauder, busker & trær"
    },
    {
        id: 2,
        name: "Inneplanter",
        image: "https://customer-assets.emergentagent.com/job_hageplanter-no/artifacts/de1y2pn2_image.png",
        count: "Grønne & blomstrende"
    },
    {
        id: 3,
        name: "Roser",
        image: "https://images.unsplash.com/photo-1626436098119-7ad0a384e0e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
        count: "Kvalitetsroser"
    },
    {
        id: 4,
        name: "Jord & Bark",
        image: "https://images.pexels.com/photos/7728740/pexels-photo-7728740.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        count: "Alt til planting"
    },
    {
        id: 5,
        name: "Krukker",
        image: "https://images.unsplash.com/photo-1485955900006-10f4d324d411?q=80&w=2944&auto=format&fit=crop",
        count: "Ute & inne"
    },
    {
        id: 6,
        name: "Hageredskap",
        image: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?q=80&w=2940&auto=format&fit=crop",
        count: "Kvalitetsutstyr"
    }
];

export const products = [
    {
        id: 1,
        name: "Rose 'Tåsen Rød'",
        scientific: "Rosa sp.",
        price: 299,
        originalPrice: 349,
        image: "https://images.unsplash.com/photo-1626436098119-7ad0a384e0e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
        badge: "Ukens Utvalgte",
        category: "Uteplanter"
    },
    {
        id: 2,
        name: "Monstera Deliciosa",
        scientific: "Monstera deliciosa",
        price: 399,
        image: "https://images.pexels.com/photos/17075186/pexels-photo-17075186.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        badge: "Bestselger",
        category: "Inneplanter"
    },
    {
        id: 3,
        name: "Hortensia Blå",
        scientific: "Hydrangea macrophylla",
        price: 249,
        image: "https://images.unsplash.com/photo-1505312896587-a2e6f48386f6?q=80&w=2940&auto=format&fit=crop",
        category: "Uteplanter"
    },
    {
        id: 4,
        name: "Terracotta Potte XL",
        scientific: "Frostsikker",
        price: 599,
        originalPrice: 799,
        image: "https://images.unsplash.com/photo-1485955900006-10f4d324d411?q=80&w=2944&auto=format&fit=crop",
        badge: "Tilbud",
        category: "Potter"
    },
    {
        id: 5,
        name: "Kugjødselkompost",
        scientific: "50 Liter",
        price: 149,
        image: "https://images.pexels.com/photos/7728740/pexels-photo-7728740.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        category: "Jord & Gjødsel"
    },
    {
        id: 6,
        name: "Fiskars Hagesaks",
        scientific: "Ergonomisk",
        price: 299,
        image: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?q=80&w=2940&auto=format&fit=crop",
        category: "Redskap"
    }
];

export const articles = [
    {
        id: 1,
        title: "Klargjør hagen for våren",
        excerpt: "Våre gartnere gir deg de beste tipsene for å vekke hagen til liv etter vinteren. Slik beskjærer du rosene.",
        image: "https://customer-assets.emergentagent.com/job_hageplanter-no/artifacts/2vl39vgf_image.png",
        date: "Mars 2024"
    },
    {
        id: 2,
        title: "Slik lykkes du med stueplanter",
        excerpt: "Enkle grep som gjør at de grønne plantene dine trives bedre. Lys, vann og næring er nøkkelen.",
        image: "https://customer-assets.emergentagent.com/job_hageplanter-no/artifacts/de1y2pn2_image.png",
        date: "Feb 2024"
    },
    {
        id: 3,
        title: "Dyrk dine egne urter",
        excerpt: "Ingenting smaker bedre enn hjemmedyrket. Se hvilke urter som passer best i vinduskarmen.",
        image: "https://images.unsplash.com/photo-1592841200221-a6898f307baa?q=80&w=2787&auto=format&fit=crop",
        date: "Jan 2024"
    }
];
